import {
  PlaylistConstants,
  PlaylistContentDto,
  PlaylistStoryDto,
  PlaylistTimerDto,
} from "@/models/PlaylistPageTypes";
import { STORY_TYPE } from "@/models/StoryTypeEnum";
import { defineStore } from "pinia";
import { ref } from "vue";

export const usePlaylistStore = defineStore("playlistStore", () => {
  const defaultPlaylistApi = "PlaylistPage";
  const progressBarDefaultStartValue = 0;
  const progressBarDefaultEndValue = 100;

  const progressMeasurementsInterval = 200;

  const stories = ref<Array<PlaylistStoryDto>>([]);
  const title = ref<string>();
  const description = ref<string>();

  const localization = ref<{ [key: string]: string }>({});

  const autoplayMode = ref<boolean>(true);
  const autoplayTimer = ref<number>()
  const currentElement = ref<string>();

  const progressArray = ref<Array<{ [key: string]: number }>>([]);

  function switchAutoplay() {
    autoplayMode.value = !autoplayMode.value;
  }

  async function autoplaySwitch(nextElement: PlaylistTimerDto | null, presentElement: PlaylistStoryDto) {
    const presentKey = presentElement.KeyId
    if (Math.round(progressArray.value[presentKey]) === progressBarDefaultEndValue)
    {
      progressArray.value[presentKey] = progressBarDefaultStartValue
    }
    window.clearInterval(autoplayTimer.value)

    const switchTimer = (presentElement?.ViewDuration && presentElement.ViewDuration > 0) ? presentElement.ViewDuration : PlaylistConstants.DEFAULT_DURATION
    
    autoplayTimer.value = setInterval(() => {
      progressArray.value[presentKey] += (progressMeasurementsInterval/switchTimer) * 100

      if (Math.round(progressArray.value[presentKey]) === progressBarDefaultEndValue)
      {
        clearInterval(autoplayTimer.value)
      }
      if (nextElement?.Element && autoplayMode.value && Math.round(progressArray.value[presentKey]) === progressBarDefaultEndValue)
      {
        nextElement.Element.click();
      }
      }, progressMeasurementsInterval )
  }

  async function SetTimerCycle(stories: Array<PlaylistStoryDto> | undefined, story: PlaylistStoryDto) {
    clearInterval(autoplayTimer.value)
    if (stories) {
      currentElement.value = story.KeyId;
      const element = document.getElementById(story.KeyId)?.parentElement?.nextElementSibling?.firstChild as HTMLElement;
      const index = stories?.indexOf(story);
      autoplaySwitch(element ? new PlaylistTimerDto(element, stories[index + 1].ViewDuration, stories[index + 1].Type) : null, story)
    }
  }

  // apiName: "MediaPlaylistPage" on a Media Playlist page (data-api); absent on a Playlist page.
  async function fetchPlaylist(id: string, apiName?: string) {
    const currentCulture =
      document.documentElement.dataset.culture?.toString() ?? "";
    const resp = await fetch(`api/${apiName || defaultPlaylistApi}/${id}`, {
      headers: {
        culture: currentCulture,
      },
    });
    const data = (await resp.json()) as PlaylistContentDto;
    stories.value = data.ListOfStories;
    title.value = data.Title;
    description.value = data.Description;
    localization.value = data.Localization;
  }

  async function initProgressArray() {
    stories.value.forEach((item) => {
      if(item.Type == STORY_TYPE.Image || item.Type == STORY_TYPE.Text)
      {
        progressArray.value[item.KeyId] = 0;
      }
    })
  }

  function getLocalization(key: string) {
    let res = ''

    try {
        res = localization.value[key]
    } catch (error) {
        console.warn(`No localization for ${key}`)
    }

    return res
}

  return {
    stories,
    title,
    description,
    autoplayMode,
    currentElement,
    autoplayTimer,
    progressMeasurementsInterval,
    getLocalization,
    initProgressArray,
    autoplaySwitch,
    fetchPlaylist,
    SetTimerCycle,
    switchAutoplay
  };
});
